import React from "react";
import BaseFormPage from "../../../../base/BaseFormPage";
import CollectionFormPresenter from "../../../collection-form/CollectionFormPresenter";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import NavBar from "../../../../components/NavBar";
import withRouter from "../../../../withRouter";
import FormFactory from "../../../../components/FormFactory";
import { menus } from "../../../main/menus";
import DropDown from "../../../../components/common/DropDown";

class ClonePermissionForm extends BaseFormPage {
  constructor(props) {
    super(props);

    // Initialize state with all potential routes
    const initialState = {
      object: {},
      advanced: false,
      name: "",
      description: "",
      updatedMenus: menus, // State variable for updated menus
      rolePermission: [],
      objectID: "",
    };

    menus.forEach((menu) => {
      if (Array.isArray(menu.route)) {
        menu.route.forEach((subRoute) => {
          initialState[subRoute.name.replace(/ /g, "")] = false;
        });
      } else {
        initialState[menu.name.replace(/ /g, "")] = false;
      }
    });

    this.state = initialState;
    this.presenter = new CollectionFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.object !== this.state.object) {
      const newStates = {};

      this.state.object.rolePermission.forEach((item) => {
        if (Array.isArray(item.route)) {
          item.route.forEach((routeItem) => {
            newStates[routeItem.name.replace(/ /g, "")] = true;
          });
        } else {
          newStates[item.name.replace(/ /g, "")] = true;
        }
      });

      if (Object.keys(newStates).length > 0) {
        this.setState(newStates);
      }
      this.setState({ objectID: this.state.object.id });
    }
  }

  getCollectionName() {
    return "roles";
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  async handleAddBTN() {
    const condition = {};
    Object.keys(this.state).forEach((key) => {
      if (
        ![
          "object",
          "advanced",
          "isTaskOpen",
          "name",
          "description",
          "isTaskEmpty",
          "updatedMenus",
        ].includes(key)
      ) {
        condition[key] = this.state[key];
      }
    });

    const updatedMenus = menus
      .map((menu) => {
        if (Array.isArray(menu.route)) {
          const filteredRoutes = menu.route.filter(
            (field) => condition[field.name.replace(/ /g, "")]
          );

          if (filteredRoutes.length > 0) {
            return {
              ...menu,
              route: filteredRoutes,
            };
          }
        } else {
          if (condition[menu.name.replace(/ /g, "")]) {
            return menu;
          }
        }
        return null;
      })
      .filter(Boolean);

    const data = {
      name: `Clone ${this.state.object.name}`,
      description: this.state.object.description,
      rolePermission: updatedMenus,
    };

    console.log("Updated Menus:", data);
    if (this.state.objectID !== "") {
      await upsertUseCase().execute("roles", data);
      this.showSuccess("Success");
      this.navigateBack();
    }

    // this.setState({ rolePermission: updatedMenus }); // Update the state with updated menus
  }

  toggleOnClick(field) {
    this.setState({ [field]: !this.state[field] });
  }

  render() {
    const object = this.state.object;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "Clone ";

    const singleRoutes = this.state.updatedMenus.filter(
      (menu) => !Array.isArray(menu.route)
    );
    const parentRoutes = this.state.updatedMenus.filter((menu) =>
      Array.isArray(menu.route)
    );

    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <h1 className="fw-bold mt-2 mb-4 text-capitalize">
                  {(schema.label || this.getCollectionName()) + " Details"}
                </h1>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.handleAddBTN();
                  }}
                >
                  <FormFactory
                    className="pb-3"
                    schema={schema}
                    object={object}
                    onChange={this.onChange.bind(this)}
                    excludeFields={["acl", "roles", "rolePermission"]}
                  />
                  <hr />
                  {parentRoutes.map((menu, index) => (
                    <DropDown
                      key={index}
                      dropdowns={[
                        {
                          title: `${menu.name}`,
                          content: menu.route.map((field, subIndex) => (
                            <div
                              key={`${index}-${subIndex}`}
                              className="row d-flex align-items-center"
                            >
                              <div className="col-lg-6">
                                <label>{field.name}</label>
                              </div>
                              <div className="col-lg-6">
                                <i
                                  className={
                                    this.state[field.name.replace(/ /g, "")]
                                      ? "bi bi-toggle-on"
                                      : "bi bi-toggle-off"
                                  }
                                  onClick={() =>
                                    this.toggleOnClick(
                                      field.name.replace(/ /g, "")
                                    )
                                  }
                                  style={{ zoom: 1.5, cursor: "pointer" }}
                                />
                              </div>
                            </div>
                          )),
                        },
                      ]}
                    />
                  ))}

                  {singleRoutes.length > 0 && (
                    <DropDown
                      dropdowns={[
                        {
                          title: "Single Routes",
                          content: singleRoutes.map((menu, index) => (
                            <div
                              key={index}
                              className="row d-flex align-items-center"
                            >
                              <div className="col-lg-6">
                                <label>{menu.name}</label>
                              </div>
                              <div className="col-lg-6">
                                <i
                                  className={
                                    this.state[menu.name.replace(/ /g, "")]
                                      ? "bi bi-toggle-on"
                                      : "bi bi-toggle-off"
                                  }
                                  onClick={() =>
                                    this.toggleOnClick(
                                      menu.name.replace(/ /g, "")
                                    )
                                  }
                                  style={{ zoom: 1.5, cursor: "pointer" }}
                                />
                              </div>
                            </div>
                          )),
                        },
                      ]}
                    />
                  )}
                  <div className="mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </button>
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ClonePermissionForm);
